import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function hexToHsl(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0, l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
      default: break;
    }
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

function lightenHsl(hslStr, amount) {
  const parts = hslStr.split(' ');
  const h = parts[0];
  const s = parseInt(parts[1]);
  const l = parseInt(parts[2]);
  return `${h} ${Math.max(s - 20, 10)}% ${Math.min(l + amount, 95)}%`;
}

function darkenHsl(hslStr, amount) {
  const parts = hslStr.split(' ');
  const h = parts[0];
  const s = parseInt(parts[1]);
  const l = parseInt(parts[2]);
  return `${h} ${s}% ${Math.max(l - amount, 10)}%`;
}

export function BrandProvider({ children }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/public/brand-settings`)
      .then(res => {
        const color = res.data?.brand_color;
        if (color) {
          applyBrandColor(color);
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return children;
}

export function applyBrandColor(hex) {
  const hsl = hexToHsl(hex);
  const root = document.documentElement;
  root.style.setProperty('--primary', hsl);
  root.style.setProperty('--ring', hsl);
  root.style.setProperty('--chart-1', hsl);
  // Accent = very light version of primary
  root.style.setProperty('--accent', lightenHsl(hsl, 55));
  root.style.setProperty('--accent-foreground', darkenHsl(hsl, 20));
  // Chart colors derived from primary
  root.style.setProperty('--chart-3', darkenHsl(hsl, 5));
  // Sidebar colors
  root.style.setProperty('--sidebar-bg', hsl);
  root.style.setProperty('--sidebar-bg-dark', darkenHsl(hsl, 5));
}
